import PermissionGuard from "@/permissions/PermissionGuard";
import { PERMISSIONS } from "@/permissions/constant";
import { useTenantScope } from "@/hooks/useTenantScope";
import TenantScopeSelect from "@/components/shared/TenantScopeSelect";
import RecordLookupScreen from "@/pages/admin/record-lookup/components/RecordLookupScreen";

/**
 * SuperAdmin-side Record Lookup — the same screens as the tenant side, plus a
 * tenant column in the results, an all-tenants toggle, and the tenant picker.
 *
 * The all-tenants toggle opts out of the ambient X-Target-Tenant-Id header
 * (`crossTenant: true` at the call site), otherwise the fleet-wide search
 * silently narrows to whichever tenant the picker last selected.
 */
const SuperAdminRecordLookup = () => {
  // `includeClosed`: a subject-access request, an erasure request or a
  // complaint arrives after an organisation is suspended or closed, and the
  // records are still there to answer for. This is the one page that has to be
  // able to name those tenants; the picker labels them so nobody mistakes one
  // for a live tenant.
  const { isSuperAdmin, tenants, tenantId, setTenantId, isLoading: tenantsLoading } = useTenantScope({ includeClosed: true });

  return (
    <PermissionGuard permission={PERMISSIONS.SUPER_ADMIN_MANAGE}>
      <RecordLookupScreen
        isSuperAdmin
        basePath="/super-admin/record-lookup"
        tenantId={tenantId}
        tenantPicker={
          <TenantScopeSelect
            tenants={tenants}
            tenantId={tenantId}
            onChange={setTenantId}
            isLoading={tenantsLoading}
            isSuperAdmin={isSuperAdmin}
            allowAll
            label="Working in"
          />
        }
      />
    </PermissionGuard>
  );
};

export default SuperAdminRecordLookup;
